import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { ContentState, EditorState, convertToRaw } from "draft-js";

import styles from "../../../SwmsMastersStyle.module.css";
import v2Styles from "../../../../v2Styles.module.css";
import EmailEditor from "../../../../../common/EmailEditor";
import layoutStyles from "../../EmergencyProceduresLayout.module.css";

export default function AddCustomEmergencyProcedureSectionModal({
  visible,
  loading,
  onCancel,
  onAdd
}) {
  const [heading, setHeading] = useState("");
  const [bodyHtml, setBodyHtml] = useState("");
  const [bodyEditorState, setBodyEditorState] = useState(() => EditorState.createEmpty());
  const [headingError, setHeadingError] = useState("");

  useEffect(() => {
    if (!visible) {
      setHeading("");
      setBodyHtml("");
      setBodyEditorState(EditorState.createEmpty());
      setHeadingError("");
    }
  }, [visible]);

  const getEditorStateFromHtml = (html = "") => {
    const blocksFromHtml = htmlToDraft(html);
    if (blocksFromHtml && blocksFromHtml.contentBlocks) {
      const contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  };

  useEffect(() => {
    if (visible) {
      setBodyEditorState(getEditorStateFromHtml(bodyHtml));
    }
  }, [visible]);

  const onBodyEditorStateChange = (newState) => {
    setBodyEditorState(newState);
    setBodyHtml(draftToHtml(convertToRaw(newState.getCurrentContent())));
  };

  const onSubmitAdd = () => {
    const trimmedHeading = `${heading || ""}`.trim();
    if (!trimmedHeading) {
      setHeadingError("Heading is required");
      return;
    }

    setHeadingError("");
    if (typeof onAdd === "function") {
      onAdd({ heading: trimmedHeading, bodyHtml: bodyHtml || "" });
    }
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      closeIcon={<div className={v2Styles.ModalCloseIcon}><CloseIcon /></div>}
      width="600px"
      style={{ top: 10 }}
    >
      <div className="v2-modal-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className={v2Styles.ModalHeading}>Add Section</div>
              <div>
                <hr className="v3-modal-hr" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className={styles.Label}>Heading</div>
              <input
                type="text"
                value={heading}
                onChange={(event) => {
                  setHeading(event.target.value);
                  if (headingError) {
                    setHeadingError("");
                  }
                }}
                placeholder="Heading"
                disabled={loading}
                className={styles.TextField}
                style={headingError ? { borderColor: "#f44336" } : undefined}
              />
              {headingError ? (
                <div className={layoutStyles.FieldErrorText}>{headingError}</div>
              ) : null}
            </div>
          </div>

          <div className="row pt-2">
            <div className="col-12">
              <div className={styles.Label}>Body</div>
              <div className="swmsv2-custom-draft-editor">
                <EmailEditor
                  editorState={bodyEditorState}
                  onEditorStateChange={onBodyEditorStateChange}
                  disabled={loading}
                  meta={{}}
                />
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-12 text-right">
              <div className={`d-flex justify-content-end align-items-center ${layoutStyles.ActionButtonsRow}`}>
                <button type="button" className={styles.OutlinedButton} onClick={onCancel} disabled={loading}>
                  Cancel
                </button>
                <button type="button" className={styles.PrimaryButton} onClick={onSubmitAdd} disabled={loading}>
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

